module.exports = __webpack_public_path__ + "static/img/14000570.2d1c4dc0.png";